// Function to update the visibility of training cards based on selected filters
const updateTrainingCardsVisibility = () => {
    const primaryFilters = [...document.querySelectorAll('#filter-dropdown-primary input:checked')].map(input => input.value);
    const modeFilter = document.querySelector('#filter-dropdown-mode input:checked')?.value || '';
    const selectedDifficulty = document.querySelector('.filter-item input[type="radio"]:checked')?.value.toLowerCase() || '';

    // Update visibility of training cards
    document.querySelectorAll('.train-cards').forEach(card => {
        const primaryValue = card.dataset.filterPrimary?.split(', ').map(value => value.trim()) || [];
        const modeValue = card.dataset.filterMode || '';
        const primaryMatches = primaryFilters.length === 0 || primaryFilters.some(filter => primaryValue.includes(filter));
        const modeMatches = !modeFilter || modeFilter === modeValue;
        const videoExists = card.querySelector('.train-card').dataset[`${selectedDifficulty}Video`];
        console.log(videoExists);
        if (primaryMatches && modeMatches && videoExists != 'false') {
            card.style.display = '';
        } else {
            card.style.display = 'none';
        }
    });

    // Update visibility of difficulty-based items
    const difficultyBasedItems = document.querySelectorAll('.js-difficulty-item');
    difficultyBasedItems.forEach(card => {
        if (card.classList.contains(selectedDifficulty)) {
            card.style.display = 'block'; 
        } else {
            card.style.display = 'none';
        }
    });

    // Update the difficulty filter label
    const selectedDifficultyLabel = document.getElementById('filter-selected-difficulty');
    if (selectedDifficultyLabel) {
        selectedDifficultyLabel.textContent = selectedDifficulty ? selectedDifficulty.charAt(0).toUpperCase() + selectedDifficulty.slice(1) : 'Select Difficulty';
    }
};

// Event listeners for dropdown and radio button selections
document.querySelectorAll('.filter-box').forEach(box => {
    const dropdownBox = box.querySelector('.dropdown-box');
    const selectedOption = box.querySelector('.selected-option');
    const dropdownList = dropdownBox.querySelector('.dropdown-list');
    const desktopDisplayElement = box.querySelector(`#filter-selected-${box.dataset.filterFor}`);
    const mobileDisplayElement = box.querySelector(`#mobile-filter-selected-${box.dataset.filterFor}`);
    const selectedDisplay = desktopDisplayElement || mobileDisplayElement;
    const applyButton = document.querySelector("#apply-filter-button");

    applyButton.addEventListener('click', () => {
        document.body.dispatchEvent(new Event('click')); // Close dropdowns on apply
        updateTrainingCardsVisibility(); // Ensure cards are updated after apply
    });

    selectedOption.addEventListener('click', () => {
        dropdownList.classList.toggle('open');
    });

    dropdownList.querySelectorAll('input').forEach(input => {
        input.addEventListener('change', () => {
            const selectedValues = [...dropdownList.querySelectorAll('input:checked')].map(checkbox => checkbox.value);

            if (selectedDisplay) {
                selectedDisplay.textContent = selectedValues.length > 0 ? selectedValues.join(', ') : 'Select an option';
            } else {
                console.error(`No element found with ID filter-selected-${box.dataset.filterFor}`);
            }

            if (desktopDisplayElement) {
                updateTrainingCardsVisibility(); // Update cards for desktop filter
            } else {
                const desktopInput = document.querySelector(`#filter-${input.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}`);
                desktopInput.checked = input.checked;
                const event = new Event('change', { bubbles: true });
                desktopInput.dispatchEvent(event);
            }
        });
    });
});

// Event listener to close dropdowns on click outside
document.addEventListener('click', event => {
    document.querySelectorAll('.dropdown-list.open').forEach(openDropdown => {
        if (!openDropdown.parentNode.contains(event.target)) {
            openDropdown.classList.remove('open');
        }
    });
});

// Initialize the filter selection text for each filter box
document.querySelectorAll('.filter-box').forEach(box => {
    const dropdownList = box.querySelector('.dropdown-list');
    const selectedOption = box.querySelector('.selected-option p');
    const selectedValues = [...dropdownList.querySelectorAll('input:checked')].map(checkbox => checkbox.value);
    const initialText = selectedValues.length > 0 ? selectedValues.join(', ') : 'Select an option';

    if (selectedOption) {
        selectedOption.textContent = initialText;
    }
});

// Difficulty filter logic
const filterRadios = document.querySelectorAll('.filter-item input[type="radio"]');
filterRadios.forEach(radio => {
    radio.addEventListener('change', updateTrainingCardsVisibility);
});

// Initial visibility update on page load
updateTrainingCardsVisibility();
